import { Component, Input } from "@angular/core";

@Component({
  selector: "mr-fieldset",
  templateUrl: "./fieldset.component.html",
  styleUrls: ["fieldset.component.scss"],
  imports: [],
})
export class FieldsetComponent {
  @Input() public header?: string;
  @Input() public description?: string;
  @Input() public kind: "nested" | "normal" = "normal";
  @Input() public disabled = false;
  @Input() public disableSpacing = false;
}
